import {Post, TreeNode} from "../../../types/Post";
import {filterPostsByCategory} from "../../../utils/category";

type FilterContentPostsProps = {
  posts: Post[];
  selectedCategory: TreeNode | null;
};

export const filterContentPosts = ({
  posts,
  selectedCategory,
}: FilterContentPostsProps) => {
  if (!selectedCategory) return [];
  return filterPostsByCategory(posts, selectedCategory);
};
